import React from 'react'
import {PROPOSAL_DETAIL} from "../../../constants/proposals";

const ProposalTab = ({
    ...props
})=>{

    return(
        <div>
        <h1>
            {
                PROPOSAL_DETAIL.title
            }

        </h1>
            <h4>
            {
                PROPOSAL_DETAIL.description
            }
            </h4>
        </div>
    )
}

export default ProposalTab